import React from 'react';

import ExportCarHireBookingsForm from '../Common/Forms/ExportCarHireBookingsForm';
import ExportCarHirePaymentStatusForm from '../Common/Forms/ExportCarHirePaymentStatusForm';
import ExportCarHireRefundsReportForm from '../Common/Forms/ExportCarHireRefundsReportForm';
import ExportWexVccPaymentsForm from '../Common/Forms/ExportWexVccPaymentsForm';

import ContentWithSidebar from './ContentWithSidebar';
import UploadCitibankStatements from './UploadCitibankStatements';
import UploadWexVccStatements from './UploadWexVccStatements';

const DEFAULT_ITEMS = 'car-hire-bookings-report';

export const items = [
  {
    slug: 'car-hire-bookings-report',
    title: 'Car Hire Bookings Report',
    component: ExportCarHireBookingsForm,
  },
  {
    slug: 'car-hire-payment-status',
    title: 'Car Hire Payment Status',
    component: ExportCarHirePaymentStatusForm,
  },
  {
    slug: 'car-hire-refunds-report',
    title: 'Car Hire Refunds Report',
    component: ExportCarHireRefundsReportForm,
  },
  {
    slug: 'upload-citibank-statement',
    title: 'Upload Citibank Statement',
    component: UploadCitibankStatements,
  },
  {
    slug: 'wex-vcc-payments-export',
    title: 'WEX VCC Payments Export',
    component: ExportWexVccPaymentsForm,
  },
  {
    slug: 'upload-wex-vcc-statement',
    title: 'Upload WEX VCC Statement',
    component: UploadWexVccStatements,
  },
];

export default function CarHirePage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_ITEMS} />;
}
